import { render, staticRenderFns } from "./wastemaker.vue?vue&type=template&id=33cc68de&scoped=true&"
import script from "./wastemaker.vue?vue&type=script&lang=js&"
export * from "./wastemaker.vue?vue&type=script&lang=js&"
import style0 from "./wastemaker.vue?vue&type=style&index=0&id=33cc68de&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc68de",
  null
  
)

export default component.exports